module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJ6ADAAQAAAABAAAAJwAAAAAd/OCSAAAAsElEQVRYCe3XwQ2AIBBEUTH2o61ZAhVoSZRgKXagSzzzl0BMjBmPDovLU0wIl13DN684frOvpys11/p2JPdLuclZ1Wr54YzpiXcrnksTeM0dIYRUKu69b7/Yk+bQhiAdyiRHOpRJjnQokxzpUCY50qFMcqRDmeRIhzLJkQ5lkiMdyiRHOpRJjnQo846Gm3d8o8krsuKZNdd6zS0VD3htiL65VlrJ/VIu79bYurKX69INmgcSceUGqvUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/part_1.png
// module id = S4lU
// module chunks = 0